import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import HomeBannerData from "../../components/admincomponents/HomeBannerData";
import FacadePageManage from "../../components/admincomponents/FacadePageManage";
import ArchitectureDesignerPageManage from "../../components/admincomponents/ArchitectureDesignerPageManage";

function ArchitectureDesignerPageBannerData({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <ArchitectureDesignerPageManage />            
    </>
  );
}

export default ArchitectureDesignerPageBannerData;
